<template>
  <div class="row product-filters mb-3 mt-2">
    <div class="col-md-3">
      <div>
        <div class="d-flex justify-content-between mt-2">
          <div>от <b>{{priceFilter.min}} ₽</b></div>
          <div>до <b>{{priceFilter.max}} ₽</b></div>
        </div>
        <b-form-slider class="ml-3" :range=true  @slide-stop="slideStop" :min=priceFilter.min :max=priceFilter.max :step=1></b-form-slider>
      </div>
    </div>
    <div class="col-md-3" v-for="filter in filteredFilters" :key="filter.type.id">
      <b>{{ filter.type.name }}</b>
      <select class="form-control" :filter-id="filter.type.id" v-model="filterTools[filter.type.id]"  @change="changeFilter">
          <option value="" >-- выберите значение --</option>
          <option :value="pval" v-for="pval in filter.possible_values" :key="pval">{{ pval }}</option>
      </select>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ProductFilters',
  props: ['filters', 'brands', 'priceFilter'],
  data() {
    return {
      filterBrand: [],
      filterTools: {},
      filterPrice: [],
      inStockOnly: false
    }
  },
  methods: {
    slideStop (data) {
      this.filterPrice = data
      this.applyFilter()
    },
    changeFilter(event) {
      if (window.$(event.target).attr('filter-id')) {
        this.filterTools[window.$(event.target).attr('filter-id')] = window.$(event.target).val()
      }
      this.applyFilter()
    },
    applyFilter() {
      this.$emit('apply-filters', {
        'price': this.filterPrice,
        'brand': this.filterBrand,
        'other': this.filterTools,
        'in_stock_only': this.inStockOnly
      });
      // this.$log(window.$(event.target).attr('filter-id'), 'apply');
    },
    clearFilters() {
      this.filters.forEach((filter) => {
        this.filterTools[filter.type.id] = ''
      });
      this.filterPrice = []
      this.$log('Filter cleared');
    },
    setParams(params) {
      if (params && params.brand) {
        this.filterBrand = params.brand
      } else {
        this.filterBrand = []
      }
      if (params && params.other) {
        for (const [key, value] of Object.entries(params.other)) {
          this.filterTools[key] = value
        }
      } else {
        this.filters.forEach((filter) => {
          this.filterTools[filter.type.id] = []
        });
      }
    },

  },
  computed: {
    filteredFilters() {
      return this.filters.filter(filter => filter.possible_values.length > 0)
    }
  },
  created: function () {
    this.filters.forEach((filter) => {
      this.filterTools[filter.type.id] = ""
    });
    // this.parseUri()
  }
}

</script>

<style scoped>
@media (min-width: 950px) {
  .filter-price {
    margin-left: 20px;
    margin-right: 15px;
  }

}

</style>